import { render, staticRenderFns } from "./step2.vue?vue&type=template&id=6f256a6f&"
import script from "./step2.vue?vue&type=script&lang=js&"
export * from "./step2.vue?vue&type=script&lang=js&"
import style0 from "./step2.vue?vue&type=style&index=0&id=6f256a6f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports